<template>
  <div class="container-fluid">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir xifres mensuals" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="form-group">
                <label for="nuevo-mes_any">Mes</label>
                <div class="input-group w-50">
                  <input type="month" class="form-control" id="nuevo-mes_any" v-model="nuevos.mensual.mes_any" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-horts_cappont">Horts Cappont</label>
                <div class="input-group w-50">
                  <input ref="autofocusCreacion" type="number" step="0.01" class="form-control" id="nuevo-horts_cappont" v-model="nuevos.mensual.horts_cappont" :disabled="loading.creacion" min="0" max="100" />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-horts_pardinyes">Horts Pardinyes</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control" id="nuevo-horts_pardinyes" v-model="nuevos.mensual.horts_pardinyes" :disabled="loading.creacion" min="0" max="100" />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-pressupostos_presentats">Pressupostos presentats</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-pressupostos_presentats" v-model="nuevos.mensual.pressupostos_presentats" :disabled="loading.creacion" min="0" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-pressupostos_acceptats">Pressupostos acceptats</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-pressupostos_acceptats" v-model="nuevos.mensual.pressupostos_acceptats" :disabled="loading.creacion" min="0" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-total_presentats">Total pressupostos presentats</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-total_presentats" v-model="nuevos.mensual.total_presentats" :disabled="loading.creacion" min="0" max="9999999.99" />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-total_acceptats">Total pressupostos acceptats</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-total_acceptats" v-model="nuevos.mensual.total_acceptats" :disabled="loading.creacion" min="0" max="9999999.99" />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-saturacio">Saturació oficina tècnica a 3 mesos vista</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control text-right" id="nuevo-saturacio" v-model="disponibilidad.saturacio" disabled required />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_lliures_1">Hores lliures mes 1</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_lliures_1" v-model="disponibilidad.hores_lliures_1" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_lliures_2">Hores lliures mes 2</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_lliures_2" v-model="disponibilidad.hores_lliures_2" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_lliures_3">Hores lliures mes 3</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_lliures_3" v-model="disponibilidad.hores_lliures_3" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_lliures_4">Hores lliures mes 4</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_lliures_4" v-model="disponibilidad.hores_lliures_4" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_lliures_5">Hores lliures mes 5</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_lliures_5" v-model="disponibilidad.hores_lliures_5" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_lliures_6">Hores lliures mes 6</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_lliures_6" v-model="disponibilidad.hores_lliures_6" disabled required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-hores_acumulades">Hores lliures acumulades pròxims 6 mesos</label>
                <div class="input-group w-50">
                  <input type="number" class="form-control" id="nuevo-hores_acumulades" v-model="disponibilidad.hores_acumulades" disabled required />
                </div>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion">
              <i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar
            </button>
          </template>
        </modal>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap xifres mensuals</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar xifres mensuals" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar xifres mensuals" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar xifres mensuals" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="form-group">
                  <label :for="`mes_any${props.row.id}`">Mes</label>
                  <div class="input-group w-50">
                    <input type="month" class="form-control" :id="`mes_any${props.row.id}`" v-model="formatearMonth(props.row.mes_any).fecha" disabled />
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`horts_cappont${props.row.id}`">Horts Cappont</label>
                  <div class="input-group w-50">
                    <input :ref="`autofocusEdicion${props.row.id}`" step="0.01" type="number" class="form-control" :id="`horts_cappont${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).horts_cappont" :disabled="loading.edicion" min="0" max="100" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`horts_pardinyes${props.row.id}`">Horts Pardinyes</label>
                  <div class="input-group w-50">
                    <input type="number" class="form-control" step="0.01" :id="`horts_pardinyes${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).horts_pardinyes" :disabled="loading.edicion" min="0" max="100" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`pressupostos_presentats${props.row.id}`">Pressupostos presentats</label>
                  <div class="input-group w-50">
                    <input type="number" class="form-control" :id="`pressupostos_presentats${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).pressupostos_presentats" :disabled="loading.edicion" min="0" max="9999999.99" />
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`pressupostos_acceptats${props.row.id}`">Pressupostos acceptats</label>
                  <div class="input-group w-50">
                    <input type="number" class="form-control" :id="`pressupostos_acceptats${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).pressupostos_acceptats" :disabled="loading.edicion" min="0" max="9999999.99" />
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`total_presentats${props.row.id}`">Total pressupostos presentats</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`total_presentats${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).total_presentats" :disabled="loading.edicion" min="0" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`total_acceptats${props.row.id}`">Total pressupostos acceptats</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`total_acceptats${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).total_acceptats" :disabled="loading.edicion" min="0" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`">
                <i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar
              </button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar xifres mensuals" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar les xifres de <b>{{ formatearMes(props.row.mes_any) }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)">
                <i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar
              </button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="mes_any" slot-scope="props">{{ formatearMes(props.cell_value) }}</template>
      <template slot="total_presentats" slot-scope="props">{{ formatearDecimales(props.cell_value) }}€</template>
      <template slot="total_acceptats" slot-scope="props">{{ formatearDecimales(props.cell_value) }}€</template>
      <template slot="mes_any_cell" slot-scope="props">
        {{ props.row.mes_any_format }}
      </template>
      <template slot="horts_cappont" slot-scope="props">{{ formatearDecimales(props.cell_value) }}%</template>
      <template slot="horts_pardinyes" slot-scope="props">{{ formatearDecimales(props.cell_value) }}%</template>
    </vue-bootstrap4-table>
    <disponibilitat-tecnica class="d-none" @reportarDisponibilidad="computarDisponibilidad" />
  </div>
</template>

<style lang="scss"></style>

<script>
import DisponibilitatTecnica from '@/views/DisponibilitatTecnica.vue';

const dia = new Date();
dia.setMonth(new Date().getMonth() - 1);
const partes = dia.toISOString().split("-");

const mensual = {
  horts_cappont: null,
  horts_pardinyes: null,
  pressupostos_presentats: null,
  pressupostos_acceptats: null,
  total_presentats: null,
  total_acceptats: null,
  mes_any: `${partes[0]}-${partes[1]}`,
};

export default {
  name: "XifresMensuals",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "actionsExportar", "formatearMes"],
  components: {
    DisponibilitatTecnica,
  },
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Mes",
          name: "mes_any_cell",
          filter: {
            type: "simple",
            placeholder: "Filtra mes",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Horts Cappont",
          name: "horts_cappont",
          filter: {
            type: "simple",
            placeholder: "Filtra horts Cappont",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Horts Pardinyes",
          name: "horts_pardinyes",
          filter: {
            type: "simple",
            placeholder: "Filtra horts Pardinyes",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Pressupostos presentats",
          name: "pressupostos_presentats",
          filter: {
            type: "simple",
            placeholder: "Filtra Pressupostos presentats",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Pressupostos acceptats",
          name: "pressupostos_acceptats",
          filter: {
            type: "simple",
            placeholder: "Filtra Pressupostos acceptats",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Total pressupostos presentats",
          name: "total_presentats",
          filter: {
            type: "simple",
            placeholder: "Filtra Total pressupostos presentats",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Total pressupostos acceptats",
          name: "total_acceptats",
          filter: {
            type: "simple",
            placeholder: "Filtra Total pressupostos acceptats",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Totes les xifres mensuals",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        mensual: { ...mensual },
      },
      disponibilidad: [],
    };
  },
  methods: {
    getData: function () {
      this.$http.get("api/mensuals").then((response) => {
        this.rows = response.data.map(row => ({
          ...row,
          mes_any_format: this.formatearMes(row.mes_any),
          mes_any_cell: `${row.mes_any} ${this.formatearMes(row.mes_any)}`,
        }));
      });
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/mensuals", { ...this.nuevos.mensual, ...this.disponibilidad })
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(() => {
            if (response.status == 201) {
              this.rows.push({
                ...response.data,
                mes_any_format: this.formatearMes(response.data.mes_any),
                mes_any_cell: `${response.data.mes_any} ${this.formatearMes(response.data.mes_any)}`,
              });

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Xifres mensuals creades correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .put(`api/mensuals/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(() => {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();

              this.rows = structuredClone(this.rowsBuffer);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Xifres mensuals editades correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/mensuals/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Xifres mensuals eliminades correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion: function () {
      this.nuevos.mensual = { ...mensual };
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    formatearMonth(mesAnyo) {
      const partes = new Date(mesAnyo).toISOString().split("-");

      return { fecha: `${partes[0]}-${partes[1]}` };
    },
    computarDisponibilidad(datos) {
      this.disponibilidad = {
        "saturacio": datos.saturacion,
        "hores_lliures_1": datos.meses[0].horasLibres,
        "hores_lliures_2": datos.meses[1].horasLibres,
        "hores_lliures_3": datos.meses[2].horasLibres,
        "hores_lliures_4": datos.meses[3].horasLibres,
        "hores_lliures_5": datos.meses[4].horasLibres,
        "hores_lliures_6": datos.meses[5].horasLibres,
        "hores_acumulades": datos.meses.filter((a, index) => index < 6).reduce((a, b) => a + b.horasLibres, 0),
      };
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>